import buttons from './buttons.json';
import components from './components.json';
import dialogs from './dialogs.json';
import form from './form.json';
import labels from './labels.json';
import notifications from './notifications.json';
import pages from './pages.json';
import validations from './validations.json';

const translations = {
  buttons,
  components,
  dialogs,
  form,
  labels,
  notifications,
  pages,
  validations
};

export default translations;
